// Client-side launch-lock gate.
// The private beta gate now only blocks new account creation (see register.tsx).
// Existing users may sign in, reset passwords, verify email, and use the app
// normally; the standard auth-gate handles anonymous access to protected
// routes. This component is retained as a passthrough to preserve the root
// route composition.
export function LaunchLockGate({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
